type Topic = {
  id: string;
  text: string;
  message?: string;
  subopt: Topic[];
}

class FeedbackTopic {
  topics: Topic[];
  #dom!: {
    form: HTMLFormElement;
    topicSelect: HTMLSelectElement;
    subtopicSelect: HTMLSelectElement;
    subtopicContainer: HTMLElement;
    resolvedTopic: HTMLInputElement;
    message: HTMLDivElement;
  };

  constructor(element: HTMLSelectElement) {
    this.topics = [];

    try {
      if(element.dataset.subjects) {
        this.topics = JSON.parse(element.dataset.subjects);
      }
    } catch(error) {
      console.error('[feedback-topic] Failed to parse feedback topics', error);
      return;
    }

    const form = element.closest('form');

    if(!form) {
      return;
    }

    const subtopicSelect = form.querySelector('#feedback_subtopic') as HTMLSelectElement;
    const message = document.createElement('div');
    message.id = 'feedback_subject_message';
    message.style.display = 'none';

    this.#dom = {
      form: form,
      topicSelect: form.querySelector('#feedback_topic') as HTMLSelectElement,
      subtopicSelect: subtopicSelect,
      subtopicContainer: subtopicSelect.closest('.form__field') as HTMLElement,
      resolvedTopic: form.querySelector('#resolved_topic') as HTMLInputElement,
      message: message,
    };

    const resolvedTopicField = this.#dom.resolvedTopic.closest('.form__field') as HTMLElement;
    if(resolvedTopicField) {
      resolvedTopicField.style.display = 'none';
    }

    this.#dom.topicSelect.innerHTML = '';
    this.#dom.subtopicSelect.innerHTML = '';

    this.#dom.subtopicContainer.style.display = 'none';
    this.#dom.subtopicContainer.after(message);

    this.topics.forEach(topic => {
      if(topic && typeof topic.text !== 'undefined') {
        const option = document.createElement('option');
        option.value = topic.id;
        option.text = topic.text;
        this.#dom.topicSelect.appendChild(option);
      }
    });

    this.#dom.topicSelect.addEventListener('change', this.onTopicChange.bind(this));
    this.#dom.subtopicSelect.addEventListener('change', this.onSubtopicChange.bind(this));

    console.log('feedback-topic.init()');
    // console.log({topics: this.topics, dom: this.#dom});
  }

  setTopic(): void {
    const topicObj = this.topics.find(topic => topic.id === this.#dom.topicSelect.value);
    const subtopicObj = topicObj?.subopt?.find(topic => topic.id === this.#dom.subtopicSelect.value);
    let topicText = '';

    if(topicObj) {
      topicText = topicObj.text;
    }

    if(subtopicObj) {
      topicText += ' - ' + subtopicObj.text;
    }

    this.#dom.resolvedTopic.value = topicText;
  };

  onTopicChange(event: Event): void {
    const target = event.target as HTMLSelectElement;
    const newTopic = this.topics.find(topic => topic.id === target.value);

    if(newTopic?.message && newTopic.message.replace(' ', '').length) {
      this.#dom.message.innerHTML = newTopic.message;
    }

    this.#dom.subtopicSelect.innerHTML = '';
    if(newTopic?.subopt?.length) {
      this.#dom.subtopicContainer.style.display = '';
      this.#dom.subtopicSelect.innerHTML = newTopic.subopt.map(subtopic => {
        if(subtopic) {
          return `<option value="${subtopic.id}">${subtopic.text}</option>`;
        }
        return '';
      }).join('');
    } else {
      this.#dom.subtopicContainer.style.display = 'none';
    }

    this.setTopic();
  }

  onSubtopicChange(event: Event) {
    const topicId = this.#dom.topicSelect.value;
    const subtopicId = this.#dom.subtopicSelect.value;
    const subtopicObj = this.topics.find(topic => topic.id === topicId)?.subopt?.find(subtopic => subtopic.id === subtopicId);

    if(subtopicObj?.message && subtopicObj.message.replace(' ', '').length) {
      this.#dom.message.innerHTML = subtopicObj.message;
      this.#dom.message.style.display = '';
    } else {
      this.#dom.message.style.display = 'none';
    }

    this.setTopic();
  }
}

export function init(element) {
  new FeedbackTopic(element);
}

export default FeedbackTopic;
